import { GET, POST } from "../components/constants/request-type";
import { service_api } from "../components/constants/url";
import { MakeRequestAsync } from "../components/functions/axios";
import { decryptSingleData } from "../components/functions/cryptojs";
import { createLogger } from "../utils/logger";

const logger = createLogger("MenuService");

class MenuService {
  async getAllergens(token) {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `allergens/get-actif`,
        data: null,
        token
      });
      return await decryptSingleData(response.data.allergens);
    } catch (error) {
      logger.error("Error fetching allergens:", error?.response?.data?.message);
      throw error;
    }
  }

  async getIngredients(token) {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `ingredient/get-actif`,
        data: null,
        token
      });
      return await decryptSingleData(response.data.ingredient);
    } catch (error) {
      logger.error(
        "Error fetching ingredients:",
        error?.response?.data?.message
      );
      throw error;
    }
  }

  async getSpicyLevels() {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `spicy/get-actif`,
        data: null,
        token: null
      });
      return await decryptSingleData(response.data.spicy);
    } catch (error) {
      logger.error(
        "Error fetching spicy levels:",
        error?.response?.data?.message
      );
      throw error;
    }
  }

  async getFoodTypes() {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `food-type/get-actif`,
        data: null,
        token: null
      });
      return await decryptSingleData(response.data.food_type);
    } catch (error) {
      logger.error(
        "Error fetching food types:",
        error?.response?.data?.message
      );
      throw error;
    }
  }

  async createFood(foodData, token) {
    try {
      const response = await MakeRequestAsync({
        type: POST,
        url: service_api,
        route: `food/chef-create-food`,
        data: foodData,
        token
      });
      return response.data;
    } catch (error) {
      logger.error("Error creating food:", error?.response?.data?.message);
      throw error;
    }
  }
}

export const menuService = new MenuService();
